export const CONFIG = {
  API_URL: process.env.REACT_APP_API_URL || 'https://tech4inventory.com/',
  S3_URL_PATH: process.env.S3_URL_PATH || 'https://go2storage.s3.us-east-2.amazonaws.com/',
  DEMO_USER: process.env.DEMO_USER || 'test@test.com',
  CHOKIDAR_USEPOLLING: process.env.CHK_USE_POLLING || 'true',
  REACT_APP_NAME: process.env.REACT_APP_NAME || 'Tech4Inventory',
  APP: {
    VERSION: '1.0.27',
  },
}
